module.exports = __webpack_public_path__ + "img/passman-demo.86e19c41.gif";